
// ------------- Add to cart handlder---------------

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".add-to-cart-btn").forEach(btn => {
        btn.addEventListener("click", async () => {
            const variant_id = btn.closest(`.product-card`).getAttribute('data-variant-id')
            const quantity = 1;
            if (!variant_id) return;

            // disable add to cart btn 
            const currentBtn = btn.closest(`.product-card[data-variant-id="${variant_id}"]`)?.querySelector('.add-to-cart-btn')
            if (currentBtn) {
                currentBtn.classList.add("disabled")
            }

            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: variant_id, quantity, sections: 'header' }),
                })

                const data = await response.json()
                if (!response.ok) {
                    throw new Error(data.message | "Couldn't add to cart")
                }

                const htmlString = data.sections['header'];
                const html = document.createElement("div")
                html.innerHTML = htmlString;
        
                const cartButtons = document.querySelectorAll(".cart .item-count")
                const updatedCartCount= html.querySelector(".cart .item-count").textContent
                if (cartButtons && updatedCartCount) {
                    cartButtons.forEach(cart => {
                        cart.textContent = updatedCartCount;
                    })
                }

            } catch (error) {
                window.alert(error.message | toString(error))
            } finally {
                currentBtn.classList.remove("disabled")
            }
        })
    })
})

// --------------------------------------------------